import { timeStampNow } from '../../tools/timeUtils';
import { normalizeUrl } from '../../tools/urlPolyfill';
import { generateUUID } from '../../tools/utils';
export var ENDPOINTS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'session-replay',
};
var INTAKE_TRACKS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'replay',
};
export var INTAKE_SITE_US = 'datadoghq.com';
export function createEndpointBuilder(initConfiguration, buildEnv, endpointType, tags, source) {
    var _a = initConfiguration.site, site = _a === void 0 ? INTAKE_SITE_US : _a, clientToken = initConfiguration.clientToken;
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var host = ENDPOINTS[endpointType] + ".browser-intake-" + domainParts.join('-') + "." + extension;
    var baseUrl = "https://" + host + "/api/v2/" + INTAKE_TRACKS[endpointType];
    var proxyUrl = initConfiguration.proxyUrl && normalizeUrl(initConfiguration.proxyUrl);
    return {
        build: function () {
            var parameters = "ddsource=" + (source || 'browser') +
                ("&ddtags=" + encodeURIComponent(["sdk_version:" + buildEnv.sdkVersion].concat(tags).join(','))) +
                ("&dd-api-key=" + clientToken) +
                ("&dd-evp-origin-version=" + encodeURIComponent(buildEnv.sdkVersion)) +
                "&dd-evp-origin=browser" +
                ("&dd-request-id=" + generateUUID());
            if (endpointType === 'rum') {
                parameters += "&batch_time=" + timeStampNow();
            }
            var endpointUrl = baseUrl + "?" + parameters;
            return proxyUrl ? proxyUrl + "?ddforward=" + encodeURIComponent(endpointUrl) : endpointUrl;
        },
        buildIntakeUrl: function () {
            return proxyUrl ? proxyUrl + "?ddforward" : baseUrl;
        },
    };
}
//# sourceMappingURL=endpointBuilder.js.map